import React from 'react';
import { motion } from 'framer-motion';
import { Heart, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useHealthMetrics } from '../hooks/useHealthMetrics';
import { RecoveryBreakdown } from '../components/recovery/RecoveryBreakdown';
import { RecoveryInsights } from '../components/recovery/RecoveryInsights';
import { RecoveryTrends } from '../components/recovery/RecoveryTrends';
import { RecoveryKnowledge } from '../components/recovery/RecoveryKnowledge';

export function RecoveryPage() {
  const navigate = useNavigate();
  const metrics = useHealthMetrics();
  const [selectedTimeframe, setSelectedTimeframe] = React.useState<'24h' | '7d' | '30d'>('24h');

  return (
    <div className="fixed inset-0 bg-background/95 backdrop-blur-xl z-[100] overflow-y-auto">
      <div className="container mx-auto px-4 py-6 max-w-4xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="relative">
              <Heart className="w-6 h-6 text-primary" />
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            </div>
            <div>
              <h2 className="text-xl font-semibold">Recovery Analysis</h2>
              <p className="text-sm text-muted-foreground">Track and optimize your recovery</p>
            </div>
          </div>
          <button
            onClick={() => navigate('/home')}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-6">
          <RecoveryBreakdown metrics={metrics} />
          <RecoveryTrends 
            metrics={metrics}
            timeframe={selectedTimeframe}
            onTimeframeChange={setSelectedTimeframe}
          />
          <RecoveryInsights metrics={metrics} />
          <RecoveryKnowledge />
        </div>
      </div>
    </div>
  );
}